import { ContainerModule, interfaces } from 'inversify';
import { CurrentWorkspaceBlImpl, ICurrentWorkspaceBl } from './CurrentWorkspace.bl';
import { CurrentWorkspaceStore, ICurrentWorkspaceStore } from './CurrentWorkspace.store';
import { CurrentWorkspaceNavigator, ICurrentWorkspaceNavigator } from './services/navigator/CurrentWorkspaceNavigator';

export const currentWorkspaceModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(ICurrentWorkspaceStore.$).to(CurrentWorkspaceStore).inSingletonScope();
  bind(ICurrentWorkspaceBl.$).to(CurrentWorkspaceBlImpl).inSingletonScope();
  bind(ICurrentWorkspaceNavigator.$).to(CurrentWorkspaceNavigator).inSingletonScope();
});
